import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';

const EpdmWrap = styled.div`
    position: relative;
    padding: 48px 28px;
    border-radius: 18px;
    background: radial-gradient(1200px 400px at 15% -10%, #f3efe8 0%, transparent 60%),
    linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
    overflow: hidden;
`;

const EpdmHeader = styled(motion.div)`
    text-align: center;
    margin-bottom: 28px;
`;

const EpdmTitle = styled.h2`
    font-size: clamp(1.8rem, 3vw, 2.2rem);
    margin: 0 0 12px;
    color: #3d6c4d;
`;

const EpdmLead = styled(motion.p)`
    font-size: 1.08rem;
    line-height: 1.7;
    color: #333;
    max-width: 960px;
    margin: 0 auto;
`;

const BadgeRow = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 14px;
`;

const Badge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    border-radius: 999px;
    background: #fff;
    color: #3d6c4d;
    border: 1px solid #e6e1d8;
    font-weight: 700;
    font-size: .9rem;
`;

const EpdmGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-top: 28px;
    @media (max-width: 960px) {
        grid-template-columns: 1fr;
    }
`;

const EpdmCard = styled(motion.article)`
    background: #fff;
    border: 1px solid #eee;
    border-radius: 16px;
    padding: 22px 22px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.05);

    h3 {
        margin: 0 0 10px;
        color: #3d6c4d;
        font-size: 1.18rem;
    }

    ul {
        margin: 0;
        padding-left: 0;
        list-style: none;
    }

    li {
        position: relative;
        padding-left: 28px;
        line-height: 1.7;
        color: #444;
    }

    li + li {
        margin-top: 6px;
    }

    li:before {
        content: "✓";
        position: absolute;
        left: 0;
        top: 0;
        transform: translateY(2px);
        font-weight: 900;
        color: #c58e50; /* акцентът, който избра */
    }
`;

const fadeInUp = {
    hidden: {opacity: 0, y: 30},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6}},
};

const fadeIn = {hidden: {opacity: 0}, visible: {opacity: 1, transition: {duration: .9}}};

export default function EpdmSection() {

    return (
        <EpdmWrap>
            <EpdmHeader
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true}}
            >
                <EpdmTitle>Какво е EPDM и защо е важно за плоския покрив</EpdmTitle>
                <EpdmLead
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                    transition={{delay: .1}}
                >
                    EPDM е еластомерна синтетична мембрана с изключителна устойчивост на UV лъчи, озон и
                    температурни амплитуди.
                    Големите формати и студеното свързване със системни ленти намаляват броя на фугите и риска от
                    течове,
                    което я прави идеално решение за <strong>плоски покриви</strong>.
                </EpdmLead>

                <BadgeRow>
                    <Badge>Плоски покриви</Badge>
                    <Badge>Без пламък</Badge>
                    <Badge>UV & озон устойчиво</Badge>
                    <Badge>Дълъг живот 30+ г.</Badge>
                </BadgeRow>
            </EpdmHeader>

            <EpdmGrid>
                <EpdmCard
                    variants={fadeIn}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <h3>Ключови ползи</h3>
                    <ul>
                        <li>Дълъг експлоатационен живот (30+ години при правилен монтаж)</li>
                        <li>Устойчивост на UV/озон и градски условия</li>
                        <li>Бърз, чист монтаж – без пламък</li>
                        <li>Сервиз, обучение и съдействие на обекта</li>
                    </ul>
                </EpdmCard>

                <EpdmCard
                    variants={fadeIn}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <h3>Защо EPDM Trading Bulgaria</h3>
                    <ul>
                        <li>Пълна система: мембрани, ленти, грундове, сифони, профили</li>
                        <li>Техническа експертиза и видеоръководства на български</li>
                        <li>Бърза логистика и съдействие при оразмеряване</li>
                        <li>Фокус върху плоски покриви – нови и ремонти</li>
                    </ul>
                </EpdmCard>
            </EpdmGrid>
        </EpdmWrap>
    );
}
